// extracted by mini-css-extract-plugin
export default {"describe":"InputChecklist_describe__jwVSP","grid":"InputChecklist_grid__gXFJo"};